// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#808080","secondaryColor":"#808080","defaultPrimaryColor":"#86364e","defaultSecondaryColor":"#ea8685","TransparentColor":"rgba(172,69,86,0.06)"};